import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-14645eda"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "flex-between"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "sms-title"
  }, "请输入验证码", -1);
});
var _hoisted_3 = {
  class: "code-content"
};
var _hoisted_4 = {
  class: "code-img"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("p", {
    class: "tip"
  }, "看不清？换一张", -1);
});
var _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确定 ");
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed, inject, ref } from 'vue';
import { phonePattern, isInIframe } from '@/utils';
import { CloseOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    var isLogin = inject('isLogin');
    var imgCodeRef = ref();
    var inIframe = isInIframe();
    var phoneOnlyRead = computed(function () {
      var _a;
      // 在btoc环境中放开这个限制
      if (inIframe) {
        return false;
      }
      // 登录状态 手机号只读
      if (isLogin) {
        return true;
      } else {
        return ((_a = applyService.item) === null || _a === void 0 ? void 0 : _a.accountGenerateType) !== 2;
      }
    });
    var phoneValid = computed(function () {
      return phonePattern.test(applyService.formState.mobile);
    });
    var btnText = computed(function () {
      return applyService.smsCodeConf.status === 'countdown' ? "".concat(applyService.smsCodeConf.count, "s\u540E\u91CD\u53D1") : '获取验证码';
    });
    var showImgVerfiy = function () {
      if (applyService.smsCodeConf.visible) return;
      if (imgCodeRef.value) {
        imgCodeRef.value.vcodeService.getImageCode();
      }
      applyService.showImgVeriy(true);
    };
    return function (_ctx, _cache) {
      var _component_a_input = _resolveComponent("a-input");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      var _component_ImageCode = _resolveComponent("ImageCode");
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_input_search = _resolveComponent("a-input-search");
      var _component_a_popover = _resolveComponent("a-popover");
      var _component_a_input_group = _resolveComponent("a-input-group");
      return _openBlock(), _createElementBlock(_Fragment, null, [_unref(applyService).ConfMobile.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "报名手机号：",
            name: "mobile"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input, {
                value: _unref(formState).mobile,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).mobile = $event;
                }),
                "allow-clear": "",
                size: "large",
                placeholder: "报名手机号",
                disabled: _unref(phoneOnlyRead)
              }, null, 8, ["value", "disabled"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true), !_unref(phoneOnlyRead) && _unref(phoneValid) ? (_openBlock(), _createBlock(_component_a_col, {
        key: 1,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "验证码：",
            name: "smsCode",
            required: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_input_group, {
                compact: "",
                class: "input-number-appear"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_a_input, {
                    size: "large",
                    value: _unref(formState).smsCode,
                    "onUpdate:value": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(formState).smsCode = $event;
                    }),
                    valueModifiers: {
                      trim: true
                    },
                    placeholder: "输入验证码",
                    type: "number",
                    style: {
                      "width": "calc(100% - 102px)"
                    }
                  }, null, 8, ["value"]), _createVNode(_component_a_popover, {
                    visible: _unref(applyService).smsCodeConf.visible,
                    trigger: "click"
                  }, {
                    title: _withCtx(function () {
                      return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_unref(CloseOutlined), {
                        class: "sms-close",
                        onClick: _cache[2] || (_cache[2] = function ($event) {
                          return _unref(applyService).showImgVeriy(false);
                        })
                      })])];
                    }),
                    content: _withCtx(function () {
                      return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_ImageCode, {
                        ref: function (_value, _refs) {
                          _refs['imgCode'] = _value;
                        },
                        onClearCode: _cache[3] || (_cache[3] = function ($event) {
                          return _unref(applyService).smsCodeConf.imgCode = '';
                        })
                      }, {
                        tips: _withCtx(function () {
                          return [_hoisted_5];
                        }),
                        _: 1
                      }, 512)]), _createVNode(_component_a_input_search, {
                        value: _unref(applyService).smsCodeConf.imgCode,
                        "onUpdate:value": _cache[4] || (_cache[4] = function ($event) {
                          return _unref(applyService).smsCodeConf.imgCode = $event;
                        }),
                        placeholder: "请输入验证码",
                        onSearch: _unref(applyService).sendVerifiedCode
                      }, {
                        enterButton: _withCtx(function () {
                          return [_createVNode(_component_a_button, {
                            type: "primary",
                            disabled: !_unref(phoneValid)
                          }, {
                            default: _withCtx(function () {
                              return [_hoisted_6];
                            }),
                            _: 1
                          }, 8, ["disabled"])];
                        }),
                        _: 1
                      }, 8, ["value", "onSearch"])])];
                    }),
                    default: _withCtx(function () {
                      return [_createVNode(_component_a_button, {
                        type: "primary",
                        size: "large",
                        class: "get-smscode",
                        disabled: _unref(applyService).smsCodeConf.status !== 'initial',
                        onClick: showImgVerfiy
                      }, {
                        default: _withCtx(function () {
                          return [_createTextVNode(_toDisplayString(_unref(btnText)), 1)];
                        }),
                        _: 1
                      }, 8, ["disabled"])];
                    }),
                    _: 1
                  }, 8, ["visible"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }
});